import { IQrCategory, IQrPartners } from '@/models/generateQr.model';

export const getStoresRow = (categories: IQrCategory[]) => {
  const mappedValues = categories?.map((value) => value.name);
  const result = categories?.length > 3 ? `${mappedValues?.join(', ')}...` : mappedValues?.join(', ');
  return result.length ? result : '-';
};

export const getCategoriesRow = (categories: IQrCategory[]) => {
  return categories?.map((value) => value.name).join(', ');
};

export const getStoresPartnersRow = (partners: IQrPartners[]) => {
  const mappedValues = partners?.map((value) => value.title);
  const result = partners?.length > 3 ? `${mappedValues?.join(', ')}...` : mappedValues?.join(', ');
  return result.length ? result : '-';
};

export const getPartnersRow = (partners: IQrPartners[]) => {
  return partners?.map((value) => value.title).join(', ');
};
